import './HeroImg.scss'
import {HeroDeco} from './HeroDeco'
import {BgDeco} from '../../../../../global-styles/deco-styles/bg-deco/BgDeco'
import {useEffect, useRef} from 'react'
import {ThanksPanel} from '../ThanksPanel/ThanksPanel'


export const HeroImage = () => {
    const ref = useRef(null)

    useEffect(() => {
        if (!ref.current) return
        if (!ref.current?.shadowRoot) return
        const template = {
            title: 'Was this page helpful to you?',
            colors: {highlight: '#41108F', text: '#ffffff'},
            buttonLabel: "Submit feedback",
            fields: [
                { type: "score-3", label: "How was your experience?" },
                { type: "textarea", label: "Comments" }
            ]
        }
        const closeBtn = ref.current?.shadowRoot.querySelector("uxf-close-button")
        closeBtn?.setAttribute('style', 'display: none')

        const formTitle = ref.current?.shadowRoot.querySelector("uxf-form-title")
        formTitle?.setAttribute('style', 'display: none')

        ref.current?.setTemplate(template)

        const formButton = ref.current?.shadowRoot.querySelector("uxf-submit-button")
        formButton?.setLabel('Submit')

    }, [ref])

    return (
        <div className={'hero-image'}>
            <div className={'circles'}>
                <BgDeco/>
                <HeroDeco/>
                <ThanksPanel/>
                <uxf-form ref={ref}></uxf-form>
            </div>
        </div>
    )
}

